import MDEditor from "@uiw/react-md-editor";
import remarkGfm from "remark-gfm";

import "@uiw/react-md-editor/markdown-editor.css";

const markdownPreviewOptions = {
  remarkPlugins: [remarkGfm],
};

export function MarkdownFieldEditor({
  id,
  value,
  onChange,
  onBlur,
}: {
  id?: string;
  value: string;
  onChange: (next: string) => void;
  onBlur?: () => void;
}) {
  return (
    <div
      id={id}
      data-color-mode="dark"
      className="w-full [&_.w-md-editor]:bg-background [&_.w-md-editor-toolbar]:bg-muted/40"
      onBlur={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget as Node | null)) {
          onBlur?.();
        }
      }}
    >
      <MDEditor
        value={value}
        onChange={(next) => onChange(next ?? "")}
        previewOptions={markdownPreviewOptions}
        height={280}
        visibleDragbar={false}
      />
    </div>
  );
}
